var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('box',{staticClass:"skill"},[_c('div',{staticClass:"skill-inner"},[_c('span',{staticClass:"skill-icon",style:(_vm.style)}),_c('br'),_c('span',{staticClass:"skill-name"},[_c('small',[_vm._v(_vm._s(_vm.name))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }